//#region IMPORTS
import { useAppDispatch, useAppSelector } from "../../store/configureStore";
import { setInstoreOrderTypeParams } from "../../features/instoreOrderTypes/instoreOrderTypesSlice";
import { SortingStateOption } from "../../models/sorting";
import { useTranslation } from "react-i18next";
import MainTableHeaderCell from "../_layout/MainTableHeaderCell";
//#endregion

export default function InstoreOrderTypesTableHeader() {
  //#region SETUP
  // Translation
  const { t } = useTranslation();

  // Redux
  const dispatch = useAppDispatch();
  const { instoreOrderType_params, loading } = useAppSelector(
    (state) => state.instoreOrderTypes
  );
  //#endregion

  //#region LOGIC

  // Set order sorting
  const sortChangedHandler = (option: SortingStateOption) => {
    if (option.column !== null) {
      dispatch(
        setInstoreOrderTypeParams({
          sort: JSON.stringify(option),
        })
      );
    } else {
      dispatch(setInstoreOrderTypeParams({ sort: undefined }));
    }
  };

  //#endregion

  //#region RENDER
  return (
    <thead>
      <tr>
        {/* read */}
        <th
          className="whitespace-nowrap pr-4 py-3.5 text-left text-xs font-semibold text-gray-900"
          scope="col"
        />
        {/* name */}
        <MainTableHeaderCell
          sortChangedHandler={(option: SortingStateOption) =>
            sortChangedHandler(option)
          }
          headerText={t("rituals.name")}
          className="whitespace-nowrap pr-4 py-3.5 text-left text-xs text-gray-900"
          sortName="name"
          disabled={loading}
          params={instoreOrderType_params}
        />
        {/* Delete */}
        <th
          scope="col"
          className="whitespace-nowrap px-2 w-16 py-3.5 text-left text-xs font-semibold text-gray-900"
        />
      </tr>
    </thead>
  );
  //#endregion
}
